module.exports = __webpack_public_path__ + "static/media/no-notifications.70c97901.png";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/no-notifications.png
// module id = 796
// module chunks = 0